import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UsersListComponent } from './users-list/users-list.component';
import { BlockUsersListComponent } from './block-users-list/block-user-list.component';

import { SurveyListComponent } from './survey-list/survey-list.component';
import { MapComponent } from './map/map.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ProfileComponent } from './profile/profile.component';
import { FieldErrorDisplayComponent } from '../shared/field-error-display/field-error-display.component';
import {ImageCropperComponent, CropperSettings, Bounds} from 'ng2-img-cropper';
import { LanguageComponent } from './language/language.component';
import { CountryComponent } from './country/country.component';
import { SurveyScoreComponent } from './survey-score/survey-score.component';
import { UserSurveyComponent } from './user-survey/user-survey.component';
import { CategoryComponent } from './category/category.component';
import { CategoryoptionComponent } from './category-option/category-option.component';

import { ViewSurveyComponent } from './view-survey/view-survey.component';
import { SurveyReportComponent } from './survey-report/survey-report.component';
import { WazQuestionComponent } from './waz-question/waz-question.component';
import { AnsweredSurveyReportComponent } from './answered-survey-report/answered-survey-report.component';
import { SurveyPricingComponent } from './survey-pricing/survey-pricing.component';
import { TransactionReportComponent } from './transaction-report/transaction-report.component';
import { GroupSurveyListComponent } from './group-survey-list/group-survey-list.component';
import { GroupListComponent } from './group-list/group-list.component';
import { SocietyGroupListComponent } from './society-group-list/society-group-list.component';
import { RedeemListComponent } from './redeem-list/redeem-list.component';

import { SurveyCommentListComponent } from './survey-comment-list/survey-comment-list.component';
import { SurveyActivityReportListComponent } from './survey-activity-report-list/survey-activity-report-list.component';
import { ProfileVerificationReportListComponent } from "./profile-verification-report-list/profile-verification-report-list.component";
import { AdminLogReportListComponent } from "./admin-log-report-list/admin-log-report-list.component";
import { ReportedCommentListComponent } from "./reported-comment-list/reported-comment-list.component";
import{ UserSurveyPostedQusestionComponent } from "./user-survey-posted-question/user-survey-posted-question.component";
import { ProfessionComponent } from './profession/profession.component';
import { GroupUsersListComponent } from './group-users-list/group-users-list/group-users-list.component';
import { SocietyUserSurveyComponent } from './society-user-survey/society-user-survey/society-user-survey.component';
import { VideoReportComponent } from './video-report/video-report.component';
import { WorldSurveysComponent } from './world-surveys/world-surveys.component';
import { StateComponent } from './state/state.component';
import { CityComponent } from './city/city.component';
import { TimeComponent } from './time/time.component';
import { YearComponent } from './year/year.component';

import { UserCreditTransactionReportComponent } from './user-credit-transaction-report/user-credit-transaction-report.component';
import { AskWazzersVideoComponent } from './ask-wazzers-video/ask-wazzers-video.component';
import { StoryVideoComponent } from './story-video/story-video.component';

import { WAZaskComponent } from './waz-ask/waz-ask.component';
import { PointComponent } from './point/point.component';

import { VideosComponent } from './videos/videos.component';
import { AdminsListComponent } from './admin-list/admin-list.component';
import { WazVideosComponent } from './waz-videos/waz-videos.component';
import { ProfessionoptionComponent } from './profession-option/profession-option.component';
import { LikeMySurveyListComponent } from './like-my-survey-list/like-my-survey-list.component'
import { QueryComponent } from './query/query.component'
import { BusinessVideoComponent } from './business-video/business-video.component'
import { InfluenceComponent } from './influence/influence.component'

import { LikeActivityReportComponent } from './like-activity-report/like-activity-report.component';
// import { FavouriteGroupSurveyComponent } from './favourite-group-survey/favourite-group-survey.component'
import { TopTrendingSurveyComponent } from './top-trending-survey/top-trending-survey.component'
// import { FavoriteCountrySurveyComponent } from './favorite-country-survey/favorite-country-survey.component'
// import { FavoriteCitySurveyComponent } from './favorite-city-survey/favorite-city-survey.component'
// import { FavoriteWazzersComponent } from './favorite-wazzers/favorite-wazzers.component'
import { StoryComponent } from './story/story.component';

import { NgxSlidesModule } from 'ngx-slides'


@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    NgxSlidesModule
  ],
  declarations: [
    DashboardComponent, GroupUsersListComponent,
    UsersListComponent, BlockUsersListComponent,
    SurveyListComponent, MapComponent,
    NotificationsComponent, ChangePasswordComponent,
    ProfileComponent, FieldErrorDisplayComponent,
    ImageCropperComponent, LanguageComponent,
    CountryComponent,    SurveyScoreComponent,
    UserSurveyComponent,     CategoryComponent,CategoryoptionComponent,
    ViewSurveyComponent,    SurveyReportComponent,
    WazQuestionComponent,    AnsweredSurveyReportComponent, 
    SurveyPricingComponent, TransactionReportComponent,
    GroupSurveyListComponent, GroupListComponent,
    SocietyGroupListComponent, SurveyCommentListComponent,RedeemListComponent,
    SurveyActivityReportListComponent, ProfileVerificationReportListComponent,
    AdminLogReportListComponent, ReportedCommentListComponent,
    UserSurveyPostedQusestionComponent,ProfessionComponent,
    GroupUsersListComponent, SocietyUserSurveyComponent, VideoReportComponent,
    WorldSurveysComponent, StateComponent, CityComponent, TimeComponent, YearComponent,
    UserCreditTransactionReportComponent,AskWazzersVideoComponent, StoryVideoComponent,
    WAZaskComponent,PointComponent,VideosComponent,AdminsListComponent,WazVideosComponent,
    ProfessionoptionComponent,LikeMySurveyListComponent,TopTrendingSurveyComponent,
    LikeActivityReportComponent,QueryComponent,BusinessVideoComponent,InfluenceComponent,StoryComponent
    //FavouriteGroupSurveyComponent,,FavoriteCountrySurveyComponent,FavoriteCitySurveyComponent,FavoriteWazzersComponent
  ],
  exports: [DashboardComponent, UsersListComponent, SurveyListComponent, MapComponent, NotificationsComponent,ChangePasswordComponent,ProfileComponent], //SurveyCommentListComponent,  SurveyActivityReportListComponent, ProfileVerificationReportListComponent, AdminLogReportListComponent, CommentActivityReportListComponent, ReportedCommentListComponent
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/dashboard.module.ts